'use client';

import SwipeableDrawer from '@/components/shared/bottom-sheet/bottom-sheet.component';
import Typography from '@/components/shared/typography/typography.component';
import { useState } from 'react';
import { useTranslation } from '@/hook';
import { HelpIcon } from '../../../../../../public/Images';
import NotifyMe from '..';

import Image from 'next/image';
import colors from '@/theme/colors.module.scss';
import useWindowDimensions, {
    DimensionsTargets,
} from '@/hook/use-window-width.hook';
import Modal from '@/components/shared/modal.component';

const NotifyMeButton = ({
    carId,
    closeOtherBottomSheet,
    closeModal = () => null,
}: {
    carId: string;
    closeOtherBottomSheet?: (flag: boolean) => void;
    closeModal?: () => void;
}) => {
    const { t, i18n } = useTranslation();
    const [notifyMeModal, setNotifyModal] = useState(false);
    const [notifyMeTooltip, setNotifyMeTooltip] = useState(false);
    const { IS_DESKTOP } = useWindowDimensions(DimensionsTargets.MOBILE);

    const toggleNotifyMeModal = () => {
        if (closeOtherBottomSheet) {
            closeOtherBottomSheet(false);
        }
        setNotifyModal(true);
    };

    return (
        <>
            <button
                style={{
                    width: '100%',
                    borderColor: '#D0D5DD',
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    borderWidth: '1px',
                    height: '100%',
                    outline: 'none',
                    border: ' 1px solid #D0D5DD',
                    display: 'flex',
                    alignItems: 'center',
                    padding: '0',
                    cursor: 'pointer',
                }}
            >
                <div
                    style={{ display: 'inline', width: '75%' }}
                    onClick={() => toggleNotifyMeModal()}
                >
                    <Typography
                        variant="body2SemiBold"
                        style={{ alignItems: 'center' }}
                    >
                        {t('Notify Me')}
                    </Typography>
                </div>

                <div
                    style={{
                        borderInlineStart: ' 1px solid #D0D5DD',
                        height: '99%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flex: 1,
                    }}
                    onClick={() => {
                        closeModal();
                        setNotifyMeTooltip(!notifyMeTooltip);
                    }}
                >
                    <Image
                        src={HelpIcon}
                        alt="HelpIcon"
                        width={16.67}
                        height={16.67}
                        style={{
                            transform:
                                i18n.language === 'ar'
                                    ? 'rotateY(180deg)'
                                    : 'unset',
                        }}
                    />
                    {notifyMeTooltip ? (
                        <div
                            style={{
                                width: '90%',
                                position: 'absolute',
                                backgroundColor: 'white',
                                borderRadius: '8px',
                                display: 'flex',
                                flexDirection: 'column',
                                padding: '12px',
                                gap: '4px',
                                alignSelf: 'center',
                                marginTop: '-5px',
                                bottom: '102px',
                                right: '3%',
                                textAlign: 'justify',
                            }}
                        >
                            <Typography
                                variant="captionMedium"
                                color={colors.gray700}
                            >
                                {t('Notify Me')}
                            </Typography>
                            <Typography
                                variant="captionMedium"
                                color={colors.gray500}
                            >
                                {t(
                                    'Clicking on Notify Me will send you a message once the car is open for reservation again'
                                )}{' '}
                            </Typography>
                            <div
                                style={{ display: 'inline' }}
                                onClick={() => setNotifyModal(false)}
                            >
                                <Typography
                                    variant="body2Medium"
                                    color={colors.primary700}
                                >
                                    {t('Got it')}
                                </Typography>
                            </div>
                        </div>
                    ) : null}
                </div>
            </button>
            {IS_DESKTOP ? (
                <Modal
                    open={notifyMeModal}
                    sx={{
                        backdropFilter: 'blur(6px)',
                        borderRadius: '12px',
                    }}
                    setOpen={setNotifyModal}
                >
                    <NotifyMe setModal={setNotifyModal} carId={carId} />
                </Modal>
            ) : (
                <>
                    <SwipeableDrawer
                        open={notifyMeModal}
                        setOpen={setNotifyModal}
                    >
                        <NotifyMe
                            setModal={setNotifyModal}
                            carId={carId}
                            clearForm={notifyMeModal}
                        />
                    </SwipeableDrawer>
                </>
            )}
        </>
    );
};

export default NotifyMeButton;
